import { toast } from 'react-toastify';
import { googleCalendarConstants } from '../constants';
import { googleCalendarService } from '../services';

const login = () => {
  const request = (googleAuth) => {
    return { type: googleCalendarConstants.LOGIN_REQUEST, googleAuth };
  };
  const success = (googleAuth) => {
    return { type: googleCalendarConstants.LOGIN_SUCCESS, googleAuth };
  };
  const failure = (error) => {
    return { type: googleCalendarConstants.LOGIN_FAILURE, error };
  };

  return (dispatch) => {
    dispatch(request());

    googleCalendarService.login().then((res) => {
      window.open(res.redirect_url, '_self')
      dispatch(success(res));
    }, 
    (error) => {
      toast.error(error.toString());
      dispatch(failure(error.toString()));
    })
  };
};

const redirect = (authCode) => {
  const request = (authStatus) => {
    return { type: googleCalendarConstants.REDIRECT_REQUEST, authStatus };
  };
  const success = (authStatus) => {
    return { type: googleCalendarConstants.REDIRECT_SUCCESS, authStatus };
  };
  const failure = (error) => {
    return { type: googleCalendarConstants.REDIRECT_FAILURE, error };
  };

  return (dispatch) => {
    dispatch(request(authCode));
    return googleCalendarService.redirect(authCode).then(
      (res) => {
        dispatch(success(res));
        return res;
      },
      (error) => {
        toast.error(error.toString());
        dispatch(failure(error.toString()));
      }
    );
  };
}

const createEvent = (eventData) => {
  const request = (event) => {
    return { type: googleCalendarConstants.CREATE_REQUEST, event };
  };
  const success = (event) => {
    return { type: googleCalendarConstants.CREATE_SUCCESS, event };
  };
  const failure = (error) => {
    return { type: googleCalendarConstants.CREATE_FAILURE, error };
  };

  return (dispatch) => {
    dispatch(request(eventData));
    return googleCalendarService.createEvent(eventData).then(
      (event) => {
        dispatch(success(event));
        return event;
      },
      (error) => {
        toast.error(error.toString());
        dispatch(failure(error.toString()));
      }
    );
  };
};

const updateEvent = (eventId, eventData) => {
  const request = (event) => {
    return { type: googleCalendarConstants.UPDATE_REQUEST, event };
  };
  const success = (event) => {
    return { type: googleCalendarConstants.UPDATE_SUCCESS, event };
  };
  const failure = (error) => {
    return { type: googleCalendarConstants.UPDATE_FAILURE, error };
  };

  return (dispatch) => {
    dispatch(request(eventData));
    return googleCalendarService.updateEvent(eventId, eventData).then(
      (event) => {
        dispatch(success(event));
        return event;
      },
      (error) => {
        toast.error(error.toString());
        dispatch(failure(error.toString()));
      }
    );
  };
};

const getEvent = (eventId) => {
  const request = (event) => {
    return { type: googleCalendarConstants.GET_REQUEST, event };
  };
  const success = (event) => {
    return { type: googleCalendarConstants.GET_SUCCESS, event };
  };
  const failure = (error) => {
    return { type: googleCalendarConstants.GET_FAILURE, error };
  };

  return (dispatch) => {
    dispatch(request(eventId));
    return googleCalendarService.getEvent(eventId).then(
      (event) => {
        dispatch(success(event));
        return event;
      },
      (error) => {
        toast.error(error.toString());
        dispatch(failure(error.toString()));
      }
    );
  };
};

const getAllEvent = (candidateId) => {
  const request = (event) => {
    return { type: googleCalendarConstants.GET_ALL_REQUEST, event };
  };
  const success = (event) => {
    return { type: googleCalendarConstants.GET_ALL_SUCCESS, event };
  };
  const failure = (error) => {
    return { type: googleCalendarConstants.GET_ALL_FAILURE, error };
  };

  return (dispatch) => {
    dispatch(request(candidateId));
    return googleCalendarService.getAllEvent(candidateId).then(
      (event) => {
        dispatch(success(event));
        return event;
      },
      (error) => {
        toast.error(error.toString());
        dispatch(failure(error.toString()));
      }
    );
  };
};

const deleteEvent = (eventId) => {
  const request = (event) => {
    return { type: googleCalendarConstants.DELETE_REQUEST, event };
  };
  const success = (event) => {
    return { type: googleCalendarConstants.DELETE_SUCCESS, event };
  };
  const failure = (error) => {
    return { type: googleCalendarConstants.DELETE_FAILURE, error };
  };

  return (dispatch) => {
    dispatch(request(eventId));
    return googleCalendarService.deleteEvent(eventId).then(
      (event) => {
        dispatch(success(event));
        return event;
      },
      (error) => {
        toast.error(error.toString());
        dispatch(failure(error.toString()));
      }
    );
  };
};

const logout = () => {
  const request = (googleAuth) => {
    return { type: googleCalendarConstants.LOGOUT_REQUEST, googleAuth };
  };
  const success = (googleAuth) => {
    return { type: googleCalendarConstants.LOGOUT_SUCCESS, googleAuth };
  };
  const failure = (error) => {
    return { type: googleCalendarConstants.LOGOUT_FAILURE, error };
  };

  return (dispatch) => {
    dispatch(request());
    return googleCalendarService.logout().then(
      (res) => {
        dispatch(success(res));
        return res;
      },
      (error) => {
        toast.error(error.toString());
        dispatch(failure(error.toString()));
      }
    );
  };
};



export const googleCalendarActions = {
  login,
  redirect,
  createEvent,
  updateEvent,
  getEvent,
  getAllEvent,
  deleteEvent,
  logout
}